export default "__VITE_ASSET__BoLAU61T__"